import React, {ReactNode} from 'react';
import './Editable.css';
import Select from "react-select";
import {Editable, EditableProps} from "./Editable";
import {useEditable} from "./EditableContext";

type Props<EnclosingType extends object, V extends any> = EditableProps<EnclosingType, V> & {
  options: { value: V, label: ReactNode }[]
}

export const EditableSingleSelect = <EnclosingType extends object, V extends any>(props: Props<EnclosingType, V>) => {

  const {mode, editing, value, setValue, errors} = useEditable<EnclosingType, V>(props);

  const findLabelForValue = (value: V | null | undefined) => {
    if (value == null) {
      return '';
    }

    for (let i = 0; i < props.options.length; i++) {
      if (props.options[i].value == value) {
        return props.options[i].label;
      }
    }

    // Fall back to the ID. Oops.
    return '[None selected]';
  }

  const findDefaultValue = (v: V | null | undefined) => {
    if (v == null) {
      return undefined;
    }
    
    for (let i = 0; i < props.options.length; i++) {
      if (props.options[i].value == v) {
        return props.options[i];
      }
    }
    return undefined;
  }

  if (mode == 'create' || (mode == 'update' && editing && !props.immutable)) {
    return <Editable {...props}>
      <Select
          value={findDefaultValue(value)}
          options={props.options}
          className="EditableMultiSelect"
          classNamePrefix={'Editable'}
          onChange={value => {
            setValue(value?.value as V)
          }}
      />
    </Editable>
  }

  return <Editable {...props}>
    <div className={'EditableNotEditing'}>
      {findLabelForValue(value)}
    </div>
  </Editable>
}